import { Filter } from "./types";

export type LibraryFilterConfig = {
  value: Filter;
  title: string;
  sentryEventName: string;
  showOnWeb?: boolean;
};

export const LIBRARY_FILTERS: LibraryFilterConfig[] = [
  {
    value: "playlist",
    title: "Playlists",
    sentryEventName: "library_filter_playlist",
  },
  {
    value: "media",
    title: "Media",
    sentryEventName: "library_filter_media",
  },
  {
    value: "artist",
    title: "Artists",
    sentryEventName: "library_filter_artist",
  },
  {
    value: "album",
    title: "Albums",
    sentryEventName: "library_filter_album",
  },
  {
    value: "downloads",
    title: "Downloads",
    sentryEventName: "library_filter_downloads",
    showOnWeb: false,
  },
];

export const getOrderedLibraryFilters = (
  filter: Filter | null,
  isWeb: boolean,
) => {
  const availableFilters = LIBRARY_FILTERS.filter(
    (config) => config.showOnWeb !== false || !isWeb,
  );
  const selectedIndex = availableFilters.findIndex(
    (config) => config.value === filter,
  );

  if (selectedIndex <= 0) {
    return availableFilters;
  }

  return [
    availableFilters[selectedIndex],
    ...availableFilters.filter((_, index) => index !== selectedIndex),
  ];
};

const OVERFLOW_TOLERANCE = 2;

export const getFilterOverflowVisibility = ({
  contentWidth,
  viewportWidth,
  offsetX,
}: {
  contentWidth: number;
  viewportWidth: number;
  offsetX: number;
}) => {
  const maxOffset = Math.max(0, contentWidth - viewportWidth);

  return {
    left: maxOffset > OVERFLOW_TOLERANCE && offsetX > OVERFLOW_TOLERANCE,
    right:
      maxOffset > OVERFLOW_TOLERANCE &&
      offsetX < maxOffset - OVERFLOW_TOLERANCE,
  };
};
